export default "/_next/static/e69667851518e035b31cabb769a11b0d.png";